// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1028 ? "a2c29f49" : chunkId) + "." + {"1028":"41f170106958317e","2741":"653c787f2490dc24","4441":"04e0d9d314094fd1","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};